//@flow

import {useState} from 'react';

import {
  createBannerCollectionService,
  updateBannerCollectionService,
  deleteBannerCollectionService,
} from '../promises/banner-collection';

import type {
  CreateBannerCollectionRequest,
  UpdateBannerCollectionRequest,
} from '../promises/banner-collection';
import type {BannerCollection} from '../../../entities/banner-collection';

export function getBannerCollectionErrorMessage(error: string) {
  if (error === 'CollectionNameAlreadyInUse') {
    return 'El nombre de la colección ya está en uso';
  }

  if (error === 'CollectionNotFound') {
    return 'La colección no existe';
  }

  return 'Ocurrió un error';
}

export function useBannerCollection() {
  const [
    bannerCollection,
    setBannerCollection,
  ] = useState<BannerCollection | null>(null);

  const createBannerCollection = (payload: CreateBannerCollectionRequest) => {
    return createBannerCollectionService(payload).then(banner => {
      setBannerCollection(banner);
      return banner;
    });
  };

  const updateBannerCollection = (
    collectionId: string,
    payload: UpdateBannerCollectionRequest
  ) => {
    return updateBannerCollectionService(collectionId, payload).then(banner => {
      setBannerCollection(banner);
      return banner;
    });
  };

  const deleteBannerCollection = (collectionId: string) => {
    return deleteBannerCollectionService(collectionId);
  };

  return {
    bannerCollection,
    createBannerCollection,
    deleteBannerCollection,
    updateBannerCollection,
  };
}
